$(document).ready(function() {   
// Wrap the two divs in a new parent div
  $('.custom-variants, .price-or-quantity').wrapAll('<div class="variant-or-quantity"></div>');
});

// =============================================================================

// ================== script of product media gallery thumbnail slider script start ==================
$(document).ready(function () {
  $('.custom-media-slider').owlCarousel({
      loop:false,
      margin:10,
      dots:true,
      nav:true,
      responsive:{
          0:{
              items:0
          },
          600:{
              items:3
          },
          1000:{
              items:4
          }
      }
  })
  // Customizing navigation buttons
  $(".custom-media-slider .owl-prev").html('<img src="https://cdn.shopify.com/s/files/1/0905/1468/6291/files/pdp_single_left_arrow.svg?v=1734519589" alt="Previous">');
  $(".custom-media-slider .owl-next").html('<img src="https://cdn.shopify.com/s/files/1/0905/1468/6291/files/pdp_single_right_arrow.svg?v=1734519589" alt="Next">');
})
// ================== script of product media gallery thumbnail slider script start ==================
